import { auth, apiQuery } from '@/api'
import VueCookie from 'vue-cookie'
import router from '@/router'

const forGetters = function(getter, value) {
  let obj = {}
  if (!Object.prototype.hasOwnProperty.call(getter.userInfo, 'details'))
    return false;
  if (!Object.prototype.hasOwnProperty.call(getter.userInfo.details, 'role'))
    return false;
  getter.userInfo.details.role.permissions.reduce(function(target, key) {
    target[key] = true;
    return target;
  }, obj);
  if (value in obj)
    return true
  else
    return false
}

const state = {
  token: VueCookie.get('x2-auth-state') || '',
  info: {}
}

const authSuccess = async (response, store) => {
  let user = response
  if (Object.prototype.hasOwnProperty.call(response,'details')
    && Object.prototype.hasOwnProperty.call(response.details,'role')
    && response.details.role.value.toLowerCase() === 'ppe'
  ) {
    await apiQuery('private', 'data-get-records', {
      table: window.x2.tables.schools
    }, false)
      .then(r => { user['ppe'] = r['rows'][0]['SYS_GUID']; })
  }
  localStorage.setItem('user', JSON.stringify(user))
  store.commit('setInfo', user)
  return user
}

const actions = {
  login (store, user) {
    return auth(user.username, user.password)
      .then(response => {
        return window.x2.auth === 'authsrv' ? store.dispatch('ssoLogin') :  authSuccess(response, store)
      })
      .catch(error => {
        throw error
      })
  },
  ssoLogin(store) {
    return apiQuery('public', 'authenticate', { type: 'x1sso' }, false).then(response => authSuccess(response, store)
    ).catch(error => {
      throw error
    })
  },
  logout (store) {
    store.commit('setToken', '')
    VueCookie.delete('x2-auth-state')
    VueCookie.delete('X1_SSO')
    localStorage.removeItem('user')
    router.push('/login')
  }
}

const mutations = {
  setInfo (state, info) {
    state.info = info
  },
  setToken (state, token) {
    state.token = token
  }
}

const getters = {
  isAuth (state) {
    return !!state.token
  },
  userInfo (state) {
    return Object.prototype.hasOwnProperty.call(state.info,'username') ? state.info : (localStorage.getItem('user') !== null ? JSON.parse(localStorage.getItem('user')) : {})
  },
  role (state, getters) {
    let info = getters.userInfo
    if (Object.prototype.hasOwnProperty.call(info,'details') && Object.prototype.hasOwnProperty.call(info.details,'role'))
      return info.details.role.value.toLowerCase()
    else {
      return info.admin ? 'admin' : null
    }
  },
  isObserver(state) {
    let user = Object.prototype.hasOwnProperty.call(state.info,'username') ? state.info : JSON.parse(localStorage.getItem('user'))
    return Object.prototype.hasOwnProperty.call(user,'details') && Object.prototype.hasOwnProperty.call(user.details,'role') ? user.details.role.value === 'Observer' : false
  },
  isCommittee(state) {
    let user = Object.prototype.hasOwnProperty.call(state.info,'username') ? state.info : JSON.parse(localStorage.getItem('user'))
    return Object.prototype.hasOwnProperty.call(user,'details') && Object.prototype.hasOwnProperty.call(user.details,'role') ? user.details.role.value === 'Committee' : false
  },
  isAdmin(state) {
    let user = Object.prototype.hasOwnProperty.call(state.info,'username') ? state.info : JSON.parse(localStorage.getItem('user'))
    return user.admin || (Object.prototype.hasOwnProperty.call(user,'details') && Object.prototype.hasOwnProperty.call(user.details,'role') ? user.details.role.value === 'Admin' : false)
  },
  canOgeOnline(state, getters) {
    return forGetters(getters, 'oge_online')

  },
  canEgeOnline(state, getters) {
    return forGetters(getters, 'ege_online')
  },
  canOgeArchive(state, getters) {
    return forGetters(getters, 'oge_archive')
  },
  canEgeArchive(state, getters) {
    return forGetters(getters, 'ege_archive')
  },
  canViewViolations(state, getters) {
    return forGetters(getters, 'violations')
  },
  canSubmitViolation(state, getters) {
    return forGetters(getters, 'submit_violation')
  },
  canProcessViolation(state, getters) {
    return forGetters(getters, 'process_violation')
  },
  canConfirmViolation(state, getters) {
    return forGetters(getters, 'confirm_violation')
  },
  canControlStream(state, getters) {
    return forGetters(getters, 'stream_control')
  },
  canSwitchStream(state, getters) {
    return forGetters(getters, 'stream_switch')
  },
  canSeeNews(state, getters) {
    return forGetters(getters, 'news_view')
  },
  userPpe(state, getters) {
    const role = getters.role
    const info = getters.userInfo
    if (role !== 'ppe')
      return null
    if (Object.prototype.hasOwnProperty.call(info,'ppe'))
      return info.ppe
    else
      return null
  }
}
export default {
  state,
  actions,
  mutations,
  getters
}
